module.exports = __webpack_public_path__ + "static/media/termsCheckMark.89ee978e.svg";